<template>
  <div>
    <div>
      <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleCreate()">添加</el-button>
      <el-button type="primary" icon="el-icon-download" size="mini" @click="exportXl()">导出</el-button>

      <el-input
        v-model="listQueryJL.name"
        size="mini"
        clearable
        placeholder="请输入名称"
        style="width:150px;margin-left:16px"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left:16px"
        @click="getJLList()"
        size="mini"
      >搜索</el-button>
      <el-button type="primary" size="mini" @click="handleJLUpdate()" style="margin-left:16px">编辑</el-button>
      <el-button
        type="danger"
        @click="delRow() "
        icon="el-icon-delete"
        size="mini"
        style="margin-left:16px"
      >删除</el-button>
    </div>

    <div style="margin-top:20px">
      <el-table
        ref="JLTable"
        @selection-change="handleSelectionChange"
        :key="tableKey"
        :data="JLlist"
        height="530px"
        border
        style="width:100%"
        stripe
      >
        <el-table-column type="selection" align="center" width="40"></el-table-column>
        <el-table-column
          min-width="100px"
          min-height="140px"
          :label="'活动名称'"
          align="center"
          prop="name"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          width="160px"
          min-height="140px"
          :label="'获奖等级'"
          :show-overflow-tooltip="true"
          align="center"
          prop="contents"
        ></el-table-column>

        <el-table-column
          width="100px"
          min-height="140px"
          :label="'获奖时间'"
          align="center"
          prop="times"
        ></el-table-column>

        <el-table-column
          min-width="100px"
          min-height="140px"
          align="center"
          :label="'主办单位'"
          prop="unitname"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQueryJL.page"
        :limit.sync="listQueryJL.limit"
        @pagination="handleCurrentChange"
      />
    </div>

    <el-dialog
      :fullscreen="false"
      class="dialog-mini"
      width="30%"
      title="添加"
      :visible.sync="dialogFormJL"
    >
      <el-form :model="JLform" :rules="JLrules" ref="JLform" label-width="100px">
        <el-form-item size="small" :label="'活动名称'" prop="name">
          <el-input v-model="JLform.name"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'主办单位'" prop="unitName">
          <el-input v-model="JLform.unitName"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'获奖等级'" prop="contents">
          <el-input v-model="JLform.contents"></el-input>
        </el-form-item>

        <el-form-item size="small" :label="'获奖时间'" prop="times">
          <el-date-picker
            v-model="JLform.times"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>

        <div style="text-align:center">
          <el-button size="mini" type="primary" @click="JLsubmit()">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import * as teacherInfo from '@/api/teacher/teacherInfo';
import Pagination from '@/components/Pagination';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    Pagination,
  },
  props: {
    userId: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      dialogFormJL: false,
      tableKey: 0,
      total: 0,
      JLlist: [],
      JLform: {
        id: 0,
        userId: this.userId,
        name: '',
        contents: '',
        unitName: '',
        times: '',
        createId:null,
        createName: '',
        updateId: 0,
        state: 0,
        passStatus: 0,
      },
      JLrules: {
        name: [
          { required: true, message: '教学班级不能为空', trigger: 'blur' },
        ],
        contents: [
          { required: true, message: '内容不能为空', trigger: 'blur' },
        ],
        unitName: [
          { required: true, message: '聘请单位不能为空', trigger: 'blur' },
        ],
        times: [
          { required: true, message: '获奖时间不能为空', trigger: 'blur' },
        ],
      },
      listQueryJL: {
        page: 1,
        limit: 10,
        userId: this.userId,
        name: '',
        State: 0,
      },
      multipleSelection: [],
      socreName: '',
    };
  },
  computed: {
    getinfo() {
      return this.$store.state.User.infos;
    },
  },
  created() {
    let list = JSON.parse(getInfo('infos'));
    this.socreName=list.name
    this.JLform.createId=list.id
    this.JLform.createName=list.name
    this.getJLList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCreate() {
      this.JLform = {
        id: 0,
        userId: this.userId,
        name: '',
        contents: '',
        unitName: '',
        // beginTime: '',
        // endTime: '',
        createId: JSON.parse(getInfo('infos')).id,
        createName: JSON.parse(getInfo('infos')).name,
        updateId: 0,
        state: 0,
        passStatus: 0,
      };
      this.dialogFormJL = true;
    },
    JLsubmit() {
      this.$refs['JLform'].validate((vaild) => {
        if (vaild) {
          if (this.JLform.id == 0) {
            this.JLform.userId = this.userId;
            teacherInfo.TeacherRychAdd(this.JLform).then((res) => {
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000,
              });
              this.dialogFormJL = false;
              this.getJLList();
            });
          } else {
            this.JLform.userId = this.userId; 
            this.JLform.updateId = JSON.parse(getInfo('infos')).id;
            teacherInfo.TeacherRychUpdate(this.JLform).then((res) => {
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000,
              });
              this.dialogFormJL = false;
              this.getJLList();
            });
          }
        }
      });
    },
    getJLList() {
      this.listQueryJL.userId = this.userId;
      teacherInfo.TeacherRychLoad(this.listQueryJL).then((res) => {
        res.data.forEach((element, index) => {
          res.data[index].times = element.times.slice(0, 10);
        });
        this.JLlist = res.data;
        // console.log(this.JLlist);
        this.total = res.count;
      });
    },
    handleJLUpdate(row) {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '警告',
          message: '请选择一条进行编辑',
          type: 'warning',
          duration: 2000,
        });
        return false;
      }
      if (this.multipleSelection.length > 1) {
        this.$notify({
          title: '警告',
          message: '只能选择一条进行编辑',
          type: 'warning',
          duration: 2000,
        });
        return false;
      }

      teacherInfo
        .TeacherRychGet({ id: this.multipleSelection[0].id })
        .then((res) => {
          this.JLform = Object.assign({}, res.result);
          // this.JLform = res.result;
          this.dialogFormJL = true;
        });
    },

    exportXl() {
      let that = this;
      let data = {
        page: 1,
        limit: 1000,
        userId: this.userId,
      };
      teacherInfo.TeacherRychLoad(data).then((res) => {
        res.data.forEach((element, index) => {
          res.data[index].times = element.times.slice(0, 10);
        });
        let list = res.data;
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/excel/export2Excel'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
          const tHeader = ['活动名称', '获奖类别', '获奖时间', '主办单位']; // 导出的表头名信息
          const filterVal = ['name', 'unitName', 'contents', 'times']; // 导出的表头字段名，需要导出表格字段名

          const data = that.formatJson(filterVal, list);

          export_json_to_excel(tHeader, data, this.socreName + '荣誉excel'); // 导出的表格名称，根据需要自己命名
        });
      });
    },
    //格式转换，直接复制即可
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    delRow(row) {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '警告',
          message: '请选择一条进行删除',
          type: 'warning',
          duration: 2000,
        });
      } else {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          teacherInfo
            .TeacherRychDelete(this.multipleSelection.map((u) => u.id))
            .then((res) => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success',
                duration: 2000,
              });
              this.getJLList();
            });
        });
      }
    },
    handleCurrentChange(val) {
      this.listQueryJL.page = val.page;
      this.listQueryJL.limit = val.limit;
      this.getJLList();
    },
  },
};
</script>